import axios from "axios";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../FirebaseConfig";

export const getFCM = async (userId, title, body, screen, id) => {
  const q = query(collection(db, "tokens"), where("uid", "==", userId));
  await getDocs(q).then((querySnapshot) => {
    querySnapshot.docs?.map((item) => {
      SendPushNotification(item?.data()?.token, title, body, screen, id);
    });
  });
};

export const SendPushNotification = async (token, title, body, screen, id) => {

  console.log(token, title, body, screen, id);


  var data = JSON.stringify({
    data: {
      screen,
      id,
    },
    notification: {
      body,
      title,
    },
    to: token,
  });

  const options = {
    method: "POST",
    url: "https://fcm.googleapis.com/fcm/send",
    headers: {
      Authorization:
        "key=AAAAcvCeW-M:APA91bEr44W6g075AVsD5WjvNkkPOLXHlYCvTwXS1p2dPJ_XPgj_L6rXLICbvHgWVuwM_0RAZaXklqeda4JWTcS18sXhOwk0lDHDDOwkcaCTc8lOeJzNBTcLtiJiSJh3U8AAnS4qsqo7",
      "Content-Type": "application/json",
    },
    data: data,
  };

  try {
    axios
      .request(options)
      .then(function (response) {
        console.log(response.data);
      })
      .catch(function (error) {
        console.error(error);
      });
  } catch (error) {
    console.log("error", error);
  }
};
